import type { Swimmer } from "../../../../api/client/types/swimmer.types";
import type { EditSwimmerFormData } from "../../components/EditSwimmerForm/EditSwimmerForm.types";

export const mapSwimmerToInitialData = (
  swimmer: Swimmer
): Partial<EditSwimmerFormData> => {
  return {
    name: swimmer.name ?? "",
    building_tower: swimmer.building_tower ?? "",
    building_apartment: swimmer.building_apartment ?? "",
    swimmer_type_id:
      swimmer.swimmer_type?.id?.toString() ||
      swimmer.swimmer_type_id?.toString() ||
      "",
    // registration_timestamp is handled separately for admin-only editing
  };
};
